import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import { StoryblokComponent} from "gatsby-source-storyblok";

export let ModalIDs = [];

export const Modal = (story) => {  
    const modals=  useStaticQuery(
        graphql`
          query {
            allStoryblokEntry(filter: {field_component: {in: ["modal"]}}) {
              nodes {
                content
                uuid
                name
              }
            }
          }
        `
    )

    let modal_blocks = function(modals, ID){
        var modal = "";

        for( let i = 0; i < modals.allStoryblokEntry.nodes.length; i++ ){
            if(modals.allStoryblokEntry.nodes[i].uuid === ID){
                modal = JSON.parse(modals.allStoryblokEntry.nodes[i].content).modal_content
            }
        }  

        return {modal}; 
    } 
    const data = modal_blocks(modals, story.uuid);
    
    let components = false;

    if(data.modal.length > 0){
        components = data.modal.map(blok => (<StoryblokComponent blok={blok} key={blok._uid} />))
    }

    return(
        <div className="modal" id={story.uuid}>
            {components}
        </div>
    )
}